import React from 'react';

const FileIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <path d="M10 12v-1"/>
            <path d="M10 18v-2"/>
            <path d="M10 7V6"/>
            <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
            <path d="M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01"/>
            <circle cx="10" cy="20" r="2"/>
        </svg>
    );
};

export default FileIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/FileArchiveIcon.jsx